

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const RESETPASSWORDDFORAUTHUSER= createAsyncThunk(
  "resetPasswordForAuthUser/resetPasswordForAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const resetPasswordForAuthUserSlice = createSlice({
  name: "resetPasswordForAuthUserSlice",
  initialState: {
    resetPasswordForAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfresetPasswordForAuthUser: (state) => {
        state.resetPasswordForAuthUser.loading = false
        state.resetPasswordForAuthUser.error = false
        state.resetPasswordForAuthUser.data = []
        state.resetPasswordForAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(RESETPASSWORDDFORAUTHUSER.fulfilled, (state, action) => {
      state.resetPasswordForAuthUser = {
        ...state.resetPasswordForAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDDFORAUTHUSER.pending, (state, action) => {
      state.resetPasswordForAuthUser = {
        ...state.resetPasswordForAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(RESETPASSWORDDFORAUTHUSER.rejected, (state, action) => {
      state.resetPasswordForAuthUser = {
        ...state.resetPasswordForAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const resetPasswordForAuthUserAction = {
    RESETPASSWORDDFORAUTHUSER,
};

export { resetPasswordForAuthUserAction };
export default resetPasswordForAuthUserSlice.reducer;
export const {setInitialStateOfresetPasswordForAuthUser} = resetPasswordForAuthUserSlice.actions
